export function GDPRHandler() {
    this._default_types = ['strictly-necessary'];
    this.init = function () {
        this.initGDPR();
        // toggle active on buttons in privacy-banner
        $('body').on('click', '.privacy-container button', function (e) {
            let button = $(e.currentTarget);
            this._triggerAction(button.attr('data-action'));
        }.bind(this));
        // toggle informations for type
        $('body').on('click', '.information', function (e) {
            let info_type = $('.privacy-settings.' + $(this).attr('data-type'));
            $('.privacy-settings:not(.information)').removeClass('active');
            info_type.addClass('active');
        });
        $('body').on('change', 'input[type="checkbox"].decoy, .information_type input[type="checkbox"]', function(e) {
            let checked = $(this).prop('checked');
            let name = $(this).attr('name');
            let elem_to_update = $(this).closest('.privacy-container').find('.privacy-settings.infos.' + name + ' input[type="checkbox"][data-name="' + name + '"]');
            if ($(this).hasClass('decoy')) {
                name = $(this).attr('data-name');
                elem_to_update = $(this).closest('.privacy-container').find('.privacy-settings .information_type input[type="checkbox"][name="' + name + '"]');
            }
            if (elem_to_update.length) {
                elem_to_update.prop('checked', checked);
            }
        });
    };
    // get all scripts with GDPR compliance and run them after consent
    this.triggerGDPRConsent = function () {
        let types = this.getTypes();
        if (typeof types !== 'undefined' || types !== false) {
            let scripts = document.getElementsByTagName('script');
            let dom_script = null;
            for (let index = 0; index < scripts.length; index++) {
                try {
                    let script = $(scripts[index]);
                    if (script.attr('type') === 'text/plain' && !script.attr('loaded') && (types === '*' || types.includes(script.attr('data-type')))) {
                        dom_script = document.createElement('script');
                        if (typeof script.attr('src') !== 'undefined' && script.attr('src') !== false) {
                            dom_script.setAttribute('src', script.attr('src'));
                        }
                        dom_script.type = 'text/javascript';
                        dom_script.setAttribute('loaded', true);
                        dom_script.setAttribute('data-swup-ignore-script', true);
                        dom_script.async = true;
                        dom_script.innerText = script[0].innerText;
                        scripts[index].parentNode.replaceChild(dom_script, script[0]);
                    }
                } catch (err) {
                    // script failed to load
                }
            }
        }
    }

    this.initGDPR = function () {
        if (!this._hasLocalStorage()) {
            $('.privacy-container').removeClass('active');
        } else {
            // Banner Trigger if Not Closed
            if (!this.isActive()) {
                $('.privacy-container, .privacy-banner').addClass('active');
                this.setTypes(this._default_types);
            }
        }
        if (!this.enabled()) {
            this.setTypes('*');
        }
        this.triggerGDPRConsent();
    }

    this.getTypes = function () {
        if (!this._hasLocalStorage()) {
            return this._default_types;
        }
        return localStorage.types;
    }

    this.setTypes = function (types) {
        if (typeof types !== 'undefined' && types !== false) {
            localStorage.types = types;
        } else {
            localStorage.types = this._default_types;
        }
    }

    this.deleteTypes = function () {
        localStorage.removeItem('types');
    }

    this.hideGDPR = function () {
        localStorage.hide_GDPR = true;
    }

    this.enabled = function () {
        return $('.privacy-container').length > 0;
    }

    this.isActive = function () {
        if (localStorage.hide_GDPR != null) {
            return localStorage.hide_GDPR;
        }
        return false;
    }

    this._triggerAction = function (action) {
        let container = $('.privacy-container');
        let settings = container.find('.privacy-settings');
        let banner = container.find('.privacy-banner');
        switch (action) {
            case 'settings':
                settings.not('.infos').fadeIn(150);
                banner.fadeOut();
                break;

            case 'accept_all':
                this.setTypes('*');
                this.hideGDPR();
                container.removeClass('active');
                this.triggerGDPRConsent();
                break;

            case 'accept':
                let inputs = container.find('input:checked');
                types = [];
                for (let index = 0; index < inputs.length; index++) {
                    types.push($(inputs[index]).attr('name'));
                }
                this.setTypes(types);
                container.removeClass('active');
                this.triggerGDPRConsent();
                this.hideGDPR();
                break;

            case 'back':
                settings.removeClass('active');
                settings.not('.infos').addClass('active');
                break;

            case 'close':
                settings.fadeOut();
                banner.fadeIn();
                break;
        }
    }

    this._hasLocalStorage = function () {
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
}